import { Link } from "react-router-dom";
import { Card } from "antd";

import caramel from "../../../assets/caramel.jpg";
import breakfast from "../../../assets/Breakfast/breakfast1.jpg";
import prawns from "../../../assets/Dinner/dinner2.jpg";
import drink from "../../../assets/Drinks/drink1.jpg";

const menuItems = [
  {
    name: "Caramel Delight",
    desc: "Caramel Cake, Salted Caramel Gelato, Warm Caramel",
    img: caramel,
  },
  {
    name: "B & N Waffle",
    desc: "Banana, Nutella, Waffle, Peanut Butter, Marshmallow",
    img: breakfast,
    tags: ["VEGAN"],
  },
  {
    name: "Char Grilled Prawns",
    desc: "King Prawns, Garlic, Herbs, Olive Oil, Lemon",
    img: prawns,
  },
  {
    name: "Cosmopolitan",
    desc: "Citrus Vodka, Lime Juice, Cranberry Juice",
    img: drink,
  },
];

const MenuLayout = () => {
  return (
    <section className="relative py-24 px-4 bg-background-soft">
      {/* HEADER */}
      <div className="text-center mb-14">
        <p className="font-italianno text-primary-900 text-[34px] sm:text-[40px]">
          More Dishes
        </p>
        <h2 className="mt-2 text-primary-900 text-[22px] sm:text-[26px] tracking-[0.3em] font-semibold">
          FROM OUR MENU
        </h2>
         <span className="block mx-auto mt-4 h-[1px] w-16 bg-primary-800/70"  />
      </div>

      {/* CONTENT */}
      <div className="relative0 max-w-4xl mx-auto">
        {/* <div className="px-6 sm:px-10 py-16 shadow-2xl"> */}

          {/* MENU ITEMS */}
         <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-12">
            {menuItems.map((item, index) => (
              <Card
                key={index}
                bordered={false}
                className="
                  relative
                  pt-12
                  bg-primary-900
                  border border-primary-200/20
                  rounded-2xl
                  transition-all
                  duration-300
                  hover:bg-primary-800
                  hover:-translate-y-1
                "
              >
                {/* OVERLAPPING IMAGE */}
                <div className=" absolute -top-8 center-x-1/2 left-1/2 transform -translate-x-1/2">
                  <img
                    src={item.img}
                    alt={item.name}
                    className="
                      w-22 h-22
                      rounded-full
                      object-cover
                      ring-2 ring-primary-100
                      shadow-lg
                    "
                  />
                </div>

                {/* CONTENT */}
                <div className="mt-4 space-y-2">
                  <div className="flex items-center gap-2">
                    <h4 className="text-primary-50 text-sm font-medium tracking-wide">
                      {item.name}
                    </h4>

                    {item.tags && (
                      <span className="
                        text-[9px]
                        px-2 py-[2px]
                        rounded-full
                        border border-primary-200/40
                        text-primary-200
                        tracking-widest
                      ">
                        {item.tags[0]}
                      </span>
                    )}
                  </div>

                  <p className="text-xs text-primary-200 leading-relaxed">
                    {item.desc}
                  </p>
                </div>
              </Card>
            ))}
          </div>


          {/* CTA */}
          <div className="text-center mt-14">
            <Link
              to="/menu"
              className="inline-flex items-center gap-2 px-10 py-3 rounded-full bg-primary-800 text-white text-sm tracking-widest hover:bg-primary-600 transition"
            >
              VIEW FULL MENU
            </Link>
          </div>

        {/* </div> */}
      </div>
    </section>
  );
};

export default MenuLayout;
